import { useEffect } from "react";
import { useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import UserManagementActions from "../../Actions/UserManagementActions";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import commonUtils from "../../helpers/commonUtils";
import usermanagementStore from "../../Stores/UsermanagementStore";
import AppConstants from "../../Constants/AppConstants";
import { Box, IconButton } from "@mui/material";
import { IoMdInformationCircleOutline } from "react-icons/io";
import RolesPermission from "./RolesPermission";
const AddRole = (props) => {
  const { userId, isAddRole, editRoleDetails } = props;
  const [role, setRole] = useState("");
  const [costCentre, setCostCentre] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [plantList, setPlantList] = useState([]);
  const [plantId, setPlantId] = useState("");
  const [plantRequired, setPlantRequired] = useState(true);
  const [equipmentGroupList, setEquipmentGroupList] = useState([]);
  const [selectedEquipmentGroup, setSelectedEquipmentGroup] = useState([]);
  const [isOrgAdmin, setIsOrgAdmin] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);

  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const overrideStrings = {
    selectSomeItems: localization.select,
    search: localization.search,
    selectAll: localization.select + " " + localization.all,
    selectAllFiltered:
      localization.select +
      " " +
      localization.all +
      "(" +
      localization.filtered +
      ")",
    allItemsAreSelected: localization.allItemSelected,
    noOptions: localization.noOptions,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let selectedEquipmentGroupIds = [];
    selectedEquipmentGroup.map((key, index) => {
      selectedEquipmentGroupIds.push(key.value);
    });

    if (!isOrgAdmin && selectedEquipmentGroup.length === 0 && plantRequired) {
      alert(localization.selectEquipmentGrp);
    } else {
      if (isAddRole) {
        var addRoleData = {
          ID: editRoleDetails ? editRoleDetails.id : AppConstants.DEFAULT_GUID,
          IsDesktop: true,
          UserId: userId,
          RoleId: role,
          AnlagegruppeID: selectedEquipmentGroupIds,
        };
        setGlobalSpinner(true);
        UserManagementActions.addOrUpdateRoleToUser(addRoleData);
      } else {
        var costCentreData = {
          UserRoleId: !editRoleDetails.kostenstelle
            ? editRoleDetails.id
            : editRoleDetails.userRoleID,
          KostenstelleID: costCentre,
        };
        setGlobalSpinner(true);
        UserManagementActions.addOrUpdateCostCentreToUser(costCentreData);
      }
    }
  };

  const getRoles = () => {
    UserManagementActions.getRoles();
  };

  const getEquipmentGroupsByPlant = () => {
    if (plantId != "") {
      setGlobalSpinner(true);
      UserManagementActions.getPlantEquipmentGroupsToAllocate(userId, plantId);
    }
  };

  useEffect(() => {
    if (editRoleDetails) {
      var role = roleList.filter((val, index) => {
        return val.bezeichnung == editRoleDetails.role;
      });
      setRole(role[0]?.id);

      var plant = plantList.filter((val, index) => {
        return val.id == editRoleDetails.werkId;
      });
      setPlantId(plant[0]?.id);

      setSelectedEquipmentGroup([
        {
          label: editRoleDetails.anlagegruppe,
          value: editRoleDetails.anlagegruppeId,
        },
      ]);
    } else {
      setRole("");
      setPlantId("");
      setSelectedEquipmentGroup([]);
    }
    editRoleDetails
      ? commonUtils.setIsEdit(true)
      : commonUtils.setIsEdit(false);
  }, [props]);

  useEffect(() => {
    getRoles();
    function getRoleSuccess() {
      var res = usermanagementStore.getRoleResult();
      if (res.length > 0) {
        if (commonUtils.isUserWerkAdmin()) {
          const _temp = res.filter((item) => item.level !== 1);
          setRoleList(_temp);
        } else {
          setRoleList(res);
        }
      } else {
        setRoleList([]);
      }
    }

    function getRoleFailure() {}

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ROLE_SUCCESS,
      getRoleSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ROLE_FAILURE,
      getRoleFailure,
    );

    function getAllocateEqipmentGroupsByPlantSuccess() {
      var res = usermanagementStore.getAllocateEquipmentgrpPlantResult();
      setEquipmentGroupList([]);
      var tempArray = [];
      if (res.length > 0) {
        res.map((row, index) => {
          tempArray.push({ label: row.bezeichnung, value: row.id });
        });
        setEquipmentGroupList(tempArray);
        setGlobalSpinner(false);
      } else {
        setEquipmentGroupList([]);
        setGlobalSpinner(false);
      }
    }

    function getAllocateEqipmentGroupsByPlantFailure() {
      setEquipmentGroupList([]);
      setSelectedEquipmentGroup([]);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_SUCCESS,
      getAllocateEqipmentGroupsByPlantSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_FAILURE,
      getAllocateEqipmentGroupsByPlantFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ROLE_SUCCESS,
        getRoleSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ROLE_FAILURE,
        getRoleFailure,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_SUCCESS,
        getAllocateEqipmentGroupsByPlantSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_FAILURE,
        getAllocateEqipmentGroupsByPlantFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getPlantSuccess() {
      var res = usermanagementStore.getPlantResult();
      if (res.length > 0) {
        setPlantList(res);
      } else {
        setPlantList([]);
      }
    }

    function getPlantFailure() {}

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_SUCCESS,
      getPlantSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_FAILURE,
      getPlantFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_SUCCESS,
        getPlantSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_FAILURE,
        getPlantFailure,
      );
    };
  }, []);

  useEffect(() => {
    getEquipmentGroupsByPlant();

    return () => {};
  }, [plantId]);

  const checkForSelectedRole = (selectedRole) => {
    if (selectedRole == "1") {
      setIsOrgAdmin(true);
      setPlantRequired(false);
      setPlantId("");
      setSelectedEquipmentGroup([]);
    } else {
      setIsOrgAdmin(false);
      setPlantRequired(true);
    }
  };
  const handlePopOverClose = () => {
    setRole("");
    setPlantId("");
    setSelectedEquipmentGroup([]);
    setPlantRequired(true);
    setIsOrgAdmin(false);
  };
  return (
    <>
      <div
        className="modal fade"
        id="addRoleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="addRoleModal"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header" style={{ position: "relative" }}>
              <div className="d-flex">
                <h5 className="modal-title" id="addRoleModalTitle">
                  {isAddRole && !editRoleDetails
                    ? localization.addRole
                    : isAddRole && editRoleDetails
                      ? localization.updateRole
                      : ""}
                </h5>
                <IconButton
                  aria-label="info"
                  className="mt-2"
                  onClick={() => setInfoDialogOpen(true)}
                >
                  <IoMdInformationCircleOutline size={20} />
                </IconButton>
              </div>
              <Box>
                <IconButton
                  onClick={handlePopOverClose}
                  aria-label="close"
                  size="small"
                  data-dismiss="modal"
                  id="addRoleModalClose"
                >
                  <span
                    aria-hidden="true"
                    style={{ fontSize: "30px", lineHeight: 1 }}
                  >
                    &times;
                  </span>
                </IconButton>
              </Box>
            </div>

            <form id="AddRoleForm" onSubmit={handleSubmit}>
              <div className="mpdal-body p-2">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="role"
                    id="role"
                    required
                    disabled={editRoleDetails}
                    value={role}
                    onChange={(e) => {
                      setRole(e.target.value);
                      checkForSelectedRole(e.target.value);
                    }}
                  >
                    <option value="">{localization.selectRole}</option>
                    {roleList.map((row, index) => {
                      return (
                        <option key={index} value={row.id}>
                          {row.level == 1
                            ? localization.organizationAdmin
                            : row.bezeichnung}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {!isOrgAdmin && (
                  <>
                    <div className="form-group">
                      <select
                        className="form-control"
                        id="plantList"
                        name="plantList"
                        required={plantRequired}
                        value={plantId}
                        onChange={(e) => {
                          setSelectedEquipmentGroup([]);
                          setPlantId(e.target.value);
                        }}
                      >
                        <option value="">{localization.selectPlant}</option>
                        {plantList.map((row, index) => {
                          return (
                            <option key={index} value={row.id}>
                              {row.bezeichnung}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="form-group">
                      <MultiSelect
                        options={equipmentGroupList}
                        value={selectedEquipmentGroup}
                        onChange={setSelectedEquipmentGroup}
                        labelledBy={localization.selectEquipmentGrp}
                        closeOnChangedValue={false}
                        overrideStrings={overrideStrings}
                      />
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <div className="form-group">
                  <button
                    type="submit"
                    className="btn btn-lg btn-primary btn-block"
                  >
                    {localization.save}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <RolesPermission
        open={infoDialogOpen}
        onClose={() => setInfoDialogOpen(false)}
      />
    </>
  );
};

export default AddRole;
